"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toggle = void 0;
function toggle(arr, item) {
    const found = arr.indexOf(item) >= 0;
    return found ? arr.filter(i => i !== item) : [...arr, item];
}
exports.toggle = toggle;
exports.default = toggle;
